/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/exports-last */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React, { Suspense, lazy } from 'react'
import { GeneralSchema } from '@ashleynexvelsolutions/general-schema'
import { PageSpecificSchema } from '@ashleynexvelsolutions/page-specific-schema'
import { Seo } from '@ashleynexvelsolutions/seo'
import { graphql } from 'gatsby'
import { jsx } from 'theme-ui'
import Gallery from './Gallery'
import { Box } from '../components/elements'
import Layout from '../components/layout'
import { SubpageBody, SubpageHeader } from '../components/subPage'
import { SeoFunction, GeneralSchemaFunction, PageSpecificSchemaFunction } from '../DataImports'
import useLatestPosts from '../hooks/useLatestPosts'
import useTestimonials from '../hooks/useTestimonials'
import useWhyUs from '../hooks/useWhyUs'

const WhyUs = lazy(() => import('./WhyUs/WhyUs'))

const BLOCK_TRANSLATION_MAP = {
  page_Flexpage_PageBuilder_SubpageHeader: props => <SubpageHeader {...props} />,
  page_Flexpage_PageBuilder_ProjectPhotoGallery: props => <Gallery {...props} />,
}

const Page = ({ data }) => {
  const { page } = data
  const blocks = page.flexPage.pageBuilder
  const whyUs = useWhyUs()
  const testimonials = useTestimonials()
  const posts = useLatestPosts()

  function subPageHeader() {
    if (data.page.flexPage.pageBuilder !== null) {
      return data.page.flexPage.pageBuilder[0].interiorHeroImage
    }
    return null
  }

  return (
    <section>
      <GeneralSchema {...GeneralSchemaFunction()} />
      <PageSpecificSchema {...PageSpecificSchemaFunction(data)} />

      <Seo {...SeoFunction(data)} />
      <Layout>
        {subPageHeader() !== null && (
          <SubpageHeader interiorHeroImage={subPageHeader()} {...subPageHeader} />
        )}
        {page.content && <SubpageBody content={page.content} title={page.title} />}

        {blocks &&
          blocks
            .filter(
              ({ fieldGroupName }) => fieldGroupName !== 'page_Flexpage_PageBuilder_SubpageHeader',
            )
            .map((block, i) => {
              const C = BLOCK_TRANSLATION_MAP[block.fieldGroupName] || Box

              // eslint-disable-next-line react/no-array-index-key
              return <C key={i} testimonials={testimonials} posts={posts} {...block} />
            })}
        <Suspense fallback="loading">
          <WhyUs {...whyUs.pageBuilder[5]} />
        </Suspense>
      </Layout>
    </section>
  )
}

export default Page

export const PageQuery = graphql`
  query PageBuilderQuery($id: String!) {
    page: wpPage(id: { eq: $id }) {
      content
      title
      uri

      ...AcfPageBuilderFragment
      seo {
        opengraphImage {
          localFile {
            publicURL
          }
        }
        title
        metaDesc
        opengraphTitle
        opengraphDescription
        opengraphUrl
        opengraphSiteName
        opengraphType
        canonical
        twitterTitle
        twitterDescription
        twitterImage {
          sourceUrl
        }
      }
      nexvelschemapagesposts {
        videos {
          title
          url
          description
          thumbnailImage {
            sourceUrl
            localFile {
              childImageSharp {
                fixed {
                  src
                }
              }
            }
          }
          uploadDate
        }
        questionsAndAnswers {
          question
          answer
        }
        maps {
          mapUrl
        }
        digitaldocuments {
          title
        }
        images {
          image {
            date
            description
            title
            sourceUrl
            localFile {
              childImageSharp {
                fixed {
                  src
                }
              }
            }
          }
        }
        areaServedLandingPageSchema
        serviceSchema {
          serviceNameSchema
          linkToRelevantServicePageSchema
        }
        keywordsSchema {
          keywordSchema
        }
        localAwardsSchema {
          localAwardSchema
        }
        latitudeSchema
        longitudeSchema
        relevantExternalPagesSchema {
          relevantExternalPageSchema
        }
      }
    }
    wp {
      nexvelSchemaMarkup {
        nexvelschema {
          cities {
            city
          }
          services {
            service
            linkToRelevantPageOnYourWebsite
          }
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`
